export abstract class BaseService {
  static primaryKey: string = 'id';
}
